import { Injectable } from '@angular/core';
import { CanLoad, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
    providedIn: 'root'
})
export class AutoLoginGuard implements CanLoad {

    constructor(private authService: AuthenticationService, private router: Router) { }

    canLoad(): Observable<boolean> {

        return new Observable<boolean>(observer => {
            this.authService.isAuthenticated.subscribe(isAuthenticated => {
                if (isAuthenticated) {
                    // Obtención del tipo de usuario validado, para redirigir a una página u otra
                    this.authService.getTypeUserStorage().subscribe(typeUser => {
                        switch (typeUser) {
                            case 'employee':
                                // console.log('Llego a auto-login.guard y se hace redirección');
                                // this.router.navigateByUrl('/home-employees', { replaceUrl: true });
                                break;
                            case 'user':
                                this.router.navigateByUrl('/home', { replaceUrl: true });
                                break;
                        }
                    });
                    observer.next(false);
                } else {
                    observer.next(true);
                }
            });
        });
    }
}
